import React from "react";
import "./Sec4.css";
import Pictures from "../../../Pic";
import { Link } from "react-router-dom";

function Sec4() {
  return (
    <section className="fourColoumnSec4">
      <div className="innerSec4">
        <div className="mainHeading ">
          Snapshots of Inflatable and Advertising Balloons
        </div>
        <div className="row">
          <div className="column">
            <div className="picPan">
              <img src={Pictures.sec4.img1} alt="" />
            </div>
            <div className="textPan">
              <h4>Helium Balloons</h4>
              <p>
                Helium balloons stay for a longer than air-filled balloons,thay
                can reusable, come in many bright colours.
              </p>
              <Link to="/Products" className="cta2">view more</Link>
            </div>
          </div>
          <div className="column">
            <div className="picPan">
              <img src={Pictures.sec4.img2} alt="" />
            </div>
            <div className="textPan">
              <h4>Costumes</h4>
              <p>
                Costumes are walking character which are two types Inflatables
                Costumes and Fur Costumes they attract attention.
              </p>
              <Link to="/Products" className="cta2" >view more</Link>
            </div>
          </div>
          <div className="column">
            <div className="picPan">
              <img src={Pictures.sec4.img3} alt="" />
            </div>
            <div className="textPan">
              <h4>Sky dancers</h4>
              <p>
                Sky Dancers is the name of a line of toys and an animated show
                spin-off that were popular in the mid-1990s.
              </p>
              <Link to="/Products" className="cta2" >view more</Link>
            </div>
          </div>
          <div className="column">
            <div className="picPan">
              <img src={Pictures.sec4.img4} alt="" />
            </div>
            <div className="textPan">
              <h4>Slide bouncy</h4>
              <p>
                Slide or bounce slide, is a popular type of inflatable play
                equipment, especially used at events, and amusement parks.
              </p>
              <Link to="/Products" className="cta2" >view more</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Sec4;
